import { FirestoreDataConverter } from "firebase/firestore";
import { EventoCarteira } from "../models/eventoCarteira";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class EventoCarteiraDb extends BaseDb<
  EventoCarteira,
  { usuarioId: string; eventoId: string }
> {
  _path: string = "usuarios/usuarioId/eventos/eventoId";
  getConverter(): FirestoreDataConverter<EventoCarteira> {
    return {
      fromFirestore: (snapshot, _options) =>
        EventoCarteira.fromFirestore(snapshot.data()),
      toFirestore: (evento: EventoCarteira) => toFirestore(evento),
    };
  }
}
